// eslint-disable-next-line @stencil-community/ban-exported-const-enums
export enum FilterChangeContext {
  mobile = 'mobile',
  desktop = 'desktop',
  all = 'all',
  resetAll = 'resetAll'
}
